module.exports = __webpack_public_path__ + "static/media/qrgarden.3a7ecc1f.png";